import { EllipsisVertical } from 'lucide-react'

import { LoadingButton } from '@/components/buttons/loading-button'
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

import { useMarkNotificationsAsRead } from '../mutations'
import { useNotifications } from '../queries'

const NotificationMenu = () => {
	const {
		data: { notifications },
	} = useNotifications({
		is_read: false,
		exclude_channel: 'global',
	})

	const { mutate: markAllAsRead, isPending } = useMarkNotificationsAsRead()

	const handleMarkAllAsRead = () => {
		markAllAsRead(notifications.map((n) => n.id))
	}

	return (
		<DropdownMenu>
			<DropdownMenuTrigger
				render={
					<LoadingButton variant="ghost" size="icon" isLoading={isPending}>
						<EllipsisVertical className="size-4" />
					</LoadingButton>
				}
				className="z-50"
			/>

			<DropdownMenuContent className="z-50 min-w-48">
				<DropdownMenuGroup>
					<DropdownMenuLabel>Actions</DropdownMenuLabel>
					<DropdownMenuSeparator />
					<DropdownMenuItem
						onClick={handleMarkAllAsRead}
						className="hover:bg-muted cursor-pointer"
						disabled={notifications.length === 0}
					>
						Mark all as read{' '}
						{notifications.length > 0 && `(${notifications.length})`}
					</DropdownMenuItem>
				</DropdownMenuGroup>
			</DropdownMenuContent>
		</DropdownMenu>
	)
}

export default NotificationMenu
